'use client';

import { useEffect, useState } from 'react';
import { IconBrandFacebook, IconBrandX, IconBrandLinkedin, IconMail } from '@tabler/icons-react';
import { Tag } from '../Tag/Tag';

const Share = () => {
  const [pageTitle, setPageTitle] = useState<string | null>(null);
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (url && pageTitle) return;

    setUrl(encodeURI(window.location.href));
    setPageTitle(encodeURI(document.title));
  }, [pageTitle, url]);

  return (
    <div className="my-regular">
      <p className="w-full font-bold">Share:</p>
      <div className="flex flex-wrap gap-2">
        <Tag
          as="a"
          href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
          ariaLabel="Click to share this page on Facebook"
        >
          <IconBrandFacebook size={24} />
        </Tag>
        <Tag
          as="a"
          href={`https://x.com/intent/post?url=${url}&text=${pageTitle}`}
          ariaLabel="Click to share this page on X"
        >
          <IconBrandX size={24} />
        </Tag>
        <Tag
          as="a"
          href={`https://www.linkedin.com/shareArticle?mini=true&url=${url}`}
          ariaLabel="Click to share this page on LinkedIn"
        >
          <IconBrandLinkedin size={24} />
        </Tag>
        <Tag as="a" href={`mailto:?subject=${pageTitle}&body=${url}`} ariaLabel="Click to share this page by email">
          <IconMail size={24} />
        </Tag>
      </div>
    </div>
  );
};

export default Share;
